/** Human-readable organisation label for admin UI (never show raw UUID as primary text). */

export function formatOrganisationDisplay(org) {
  if (!org) return "";
  if (typeof org === "string") return org.trim();
  const name =
    org.name ||
    org.organisation_name ||
    org.trade_name ||
    org.legal_name ||
    "";
  return String(name).trim();
}

export function organisationPrimaryLabel(organisationName, organisationId) {
  const name = String(organisationName || "").trim();
  if (name) return name;
  if (organisationId) return "Your organisation";
  return "";
}
